import Loading from 'components/Loading/Loading';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import ReactTooltip from 'react-tooltip';
import { isMacintosh } from 'services/Helper';
import { useFilePicker } from 'use-file-picker';
import './SendInputAttachmentUpload.scss';

interface SendInputAttachmentUploadProps {
  onFilesSelected?: (any) => void;
  attachments: File[];
  attachmentsUpdated: (any) => void;
}

const SendInputAttachmentUpload = forwardRef(
  (
    {
      onFilesSelected,
      attachments = [],
      attachmentsUpdated,
    }: SendInputAttachmentUploadProps,
    ref,
  ) => {
    const [openFileSelector, { plainFiles, loading, clear, errors }] =
      useFilePicker({
        readAs: 'DataURL',
        accept: [
          '.json',
          '.pdf',
          '.txt',
          '.xlsx',
          'image/*',
          '.mp4',
          '.mp3',
          '.mov',
          '.webp',
          '.webm',
        ],
        multiple: false,
        limitFilesConfig: { max: 1 },
        maxFileSize: 10,
      });

    useImperativeHandle(ref, () => ({
      clearFiles() {
        clear();
      },
    }));

    useEffect(() => {
      if (onFilesSelected) {
        onFilesSelected(plainFiles);
      }
    }, [plainFiles]);

    if (loading) {
      return <Loading />;
    }

    const _buildAttachmentPreview = () => {
      return (
        <div className='attachments-container'>
          {attachments.map((attachment, index) => {
            return (
              <div className="input-selected-file" key={`attachment-${index}`}>
                <span>{attachment.name}</span>
                <i
                  className="fa-solid fa-xmark"
                  onClick={() => {
                    attachments.splice(index, 1);
                    attachmentsUpdated(attachments);
                  }}
                />
              </div>
            );
          })}
        </div>
      );
    };

    return (
      <>
        <ReactTooltip
          id="attachmentButtonTooltip"
          className="infoTooltip infoTooltipButton"
          delayHide={200}
          type="light"
          effect="solid"
          getContent={(content) => {
            return (
              <div className="send-key-tooltip">
                <span>{content}</span>
              </div>
            );
          }}
        />
        <div
          data-for="attachmentButtonTooltip"
          data-tip="Attach file"
          className="attachment-item"
          onClick={() => {
            openFileSelector();
          }}
        >
          <i className="fa-solid fa-paperclip" />
          {errors && errors.length > 0 && (
            <span className="attachment-item-error">
              File size limit exceeded (max. 10MB).
            </span>
          )}
        </div>
        {_buildAttachmentPreview()}
      </>
    );
  },
);

export default SendInputAttachmentUpload;
